module.exports = __webpack_public_path__ + "media/stylesheets/fonts/fontawesome/fa-brands-400-f4920c94c0861c537f72ba36590f6362.woff";